import { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import {
  Box,
  Container,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
  Alert,
  AlertIcon,
  Badge,
} from "@chakra-ui/react";
import PageLoader from "./components/PageLoader";
import api from "./api";
import { CopyIcon } from "@chakra-ui/icons";

interface UserData {
  address: string;
  referred: string[];
  _id: string;
  createdAt?: string;
}

function User() {
  const [users, setUsers] = useState<UserData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get(
        "/api/admin/user/refferal?page=1&limit=100"
      );
      setUsers(res?.data?.data || []);
    } catch (err: any) {
      setError(err?.response?.data?.message || "Error loading users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <Container maxW="container.xl" py={8}>
      <Toaster position="top-right" />
      <VStack spacing={8} align="stretch">
        <Heading as="h1" size="xl" textAlign="center">
          User Referrals
        </Heading>
        {loading && <PageLoader message="Loading users..." />}

        <Box overflowX="auto" p={4} borderRadius="lg">
          {error ? (
            <Alert status="error">
              <AlertIcon />
              {error}
            </Alert>
          ) : (
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>No.</Th>
                  <Th>Address</Th>
                  <Th>Joining Date</Th>
                  <Th>Referrals</Th>
                </Tr>
              </Thead>
              <Tbody>
                {users?.map((user: UserData, idx) => (
                  <Tr key={user._id}>
                    <Td>{idx + 1}</Td>
                    <Td>
                      <Box display="flex" alignItems="center">
                        <a rel="noopener noreferrer" style={{ marginRight: 8 }}>
                          {user?.address?.slice(0, 6)}...
                          {user?.address?.slice(-4)}
                        </a>
                        <CopyIcon
                          cursor="pointer"
                          onClick={() => {
                            navigator.clipboard.writeText(user?.address);
                            toast.success("Address copied!");
                          }}
                        />
                      </Box>
                    </Td>
                    <Td>
                      {user?.createdAt 
                        ? new Date(user.createdAt).toLocaleString()
                        : new Date('2024-10-01T00:00:00.000Z').toLocaleString()}
                    </Td>
                    <Td>
                      <VStack align="start">
                        {user?.referred?.map((referral: any, index) => (
                          <Badge key={index} colorScheme="purple">
                            {referral}
                          </Badge>
                        ))}
                      </VStack>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </Box>
      </VStack>
    </Container>
  );
}


export default User;
